(() => {
  const GIFT_VARIANT_ID = 54581391294787;
  const THRESHOLD = 6500; // 65 € en centimes

  let syncing = false;
  let queued = false;

  async function getCart() {
    const res = await fetch(`${window.Shopify.routes.root}cart.js`, {
      headers: { Accept: 'application/json' }
    });

    if (!res.ok) throw new Error('Impossible de lire le panier');

    return res.json();
  }

  function getEligibleTotal(cart) {
    return cart.items.reduce((total, item) => {
      if (Number(item.variant_id) === GIFT_VARIANT_ID) return total;
      return total + item.final_line_price;
    }, 0);
  }

  function getGift(cart) {
    return cart.items.find(
      item => Number(item.variant_id) === GIFT_VARIANT_ID
    );
  }

  async function addGift() {
    const res = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        items: [
          {
            id: GIFT_VARIANT_ID,
            quantity: 1,
            properties: {
              _automatic_free_gift: 'true'
            }
          }
        ]
      })
    });

    if (!res.ok) throw new Error('Impossible d’ajouter le cadeau');
  }

  async function changeGift(lineKey, quantity) {
    const res = await fetch(`${window.Shopify.routes.root}cart/change.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: lineKey,
        quantity
      })
    });

    if (!res.ok) throw new Error('Impossible de modifier le cadeau');
  }

  async function refreshCartDrawer() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    const sectionId = drawer.dataset.sectionId;
    if (!sectionId) return;

    const separator = window.location.search ? '&' : '?';

    const res = await fetch(
        `${window.location.pathname}${window.location.search}${separator}sections=${encodeURIComponent(sectionId)}`
    );

    if (!res.ok) return;

    const sections = await res.json();
    const html = sections[sectionId];

    if (!html) return;

    const doc = new DOMParser().parseFromString(html, 'text/html');
    const freshDrawer = doc.querySelector('cart-drawer');

    if (!freshDrawer) return;

    const replacements = [
        ['.cart-drawer-inner', '.cart-drawer-inner'],
        ['.drawer__footer-bottom', '.drawer__footer-bottom'],
        ['.cart-count', '.cart-count']
    ];

    replacements.forEach(([currentSelector, freshSelector]) => {
        const current = drawer.querySelector(currentSelector);
        const fresh = freshDrawer.querySelector(freshSelector);

        if (current && fresh) {
        current.replaceWith(fresh);
        }
    });
    }

  async function syncGift() {
    if (syncing) {
      queued = true;
      return;
    }

    syncing = true;

    try {
      const cart = await getCart();

      const eligibleTotal = getEligibleTotal(cart);
      const gift = getGift(cart);

      let changed = false;

      if (eligibleTotal >= THRESHOLD) {
        if (!gift) {
          await addGift();
          changed = true;
        } else if (gift.quantity !== 1) {
          await changeGift(gift.key, 1);
          changed = true;
        }
      } else if (gift) {
        await changeGift(gift.key, 0);
        changed = true;
      }

      if (changed) {
        await refreshCartDrawer();
      }
    } catch (error) {
      console.error('[Free Gift]', error);
    } finally {
      syncing = false;

      if (queued) {
        queued = false;
        setTimeout(syncGift, 100);
      }
    }
  }

  /*
   * Détecte automatiquement les modifications Ajax du panier effectuées
   * par le thème : ajout, suppression, changement de quantité, etc.
   */
  const originalFetch = window.fetch;

  window.fetch = async function (...args) {
    const response = await originalFetch.apply(this, args);

    try {
      const url =
        typeof args[0] === 'string'
          ? args[0]
          : args[0]?.url || '';

      const isCartMutation =
        /\/cart\/(add|change|update|clear)(\.js)?(?:\?|$)/.test(url);

      const isOurGiftRequest =
        args[1]?.headers?.['X-Free-Gift-Request'];

      if (isCartMutation && !isOurGiftRequest) {
        setTimeout(syncGift, 150);
      }
    } catch (e) {}

    return response;
  };

  /*
   * Sécurité supplémentaire :
   * certains thèmes modifient le DOM après une mutation du panier.
   */
  let mutationTimer;

  const observer = new MutationObserver(() => {
    clearTimeout(mutationTimer);

    mutationTimer = setTimeout(() => {
      if (
        document.querySelector('cart-drawer') ||
        document.querySelector('cart-items')
      ) {
        syncGift();
      }
    }, 300);
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  /*
   * Vérification au premier chargement.
   */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncGift);
  } else {
    syncGift();
  }

  /*
   * Rend également la fonction disponible pour les tests dans la console.
   */
  window.TMFreeGift = {
    sync: syncGift
  };
})();